import { render, staticRenderFns } from "./SessionPlace.vue?vue&type=template&id=b6e67fea&"
import script from "./SessionPlace.vue?vue&type=script&lang=js&"
export * from "./SessionPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports